import { BusEvent } from '@web/common';

export class UserChangedBusEvent extends BusEvent {}
